export enum CustomEventsEnum {
  BankingConsentModalResponseEvent = 'bankingConsentModalResponseEvent',
  BankingPartnerCookieModalResponseEvent = 'bankingPartnerCookieModalResponseEvent',
  OrdersPartnerOfferComponentClosedEvent = 'ordersPartnerOfferComponentClosedEvent',
  ValidIbanInsertedEvent = 'validIbanInsertedEvent',
}
